<template>
    <div class="animated fadeIn custom-cases bgV2">
        <div class="d-flex headerOrderDetail">
            <div class="orderNumber d-flex justify-content-between align-items-end pr-4 w-100">
                <div class="mt-20 pl-20">
                    <h1 class="mb-1">{{Item.job_number}}</h1>
                </div>
                <h4 class="c-orange mb-0" v-if="Item.id">{{Item.status}}</h4>
            </div>
        </div>
        <b-row>
            <b-col md="12">
                <gofix-tab
                    class="mt-3 contractPropertyTab"
                    :data="tabData">
                    <template slot="gofixTab:right">
                        <gofix-button v-if="Item && Item.id && (['Contractor Supervisor Acknowledged', 'PM Acknowledged', 'Completed'].includes(Item.status))" class="mr-3" label="Non Conformance Report" @click="reportJob"></gofix-button>
                        <gofix-button
                            v-if="Item && Item.id && !['Completed'].includes(Item.status)"
                            :disabled="!this.$checkRole(this.$accessModule.non_conformance_report, 'update')"
                            class="mr-3" 
                            label="NEXT ACTION"
                            @click="changeStatus" outline>
                        </gofix-button>
                        <gofix-button
                            :disabled="!(this.$checkRole(this.$accessModule.non_conformance_report, 'update') && !isDisabledSave)"
                            :loading="loadingSave"
                            @click="saveData"
                            label="SAVE">
                        </gofix-button>
                    </template>
                    <template slot="gofixTab:basic-info">
                        <detail-info @reloadItem="getItem" ref="basic-info" @inputType="setIsTyping"></detail-info>
                    </template>
                    <template slot="gofixTab:signature">
                        <signature :job="Item" type="non-conformance"></signature>
                    </template>
                    <template slot="gofixTab:activity-log">
                        <activities ref="activities" activityType="Job Safety" :activityId="$route.params.id"></activities>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    const Activities = () => import("../activities")
    const DetailInfo = () => import("./detail-info")
    const Signature = () => import("../detail-signature")
    export default {
        name: 'safety-inspection-checklist-detail',
        components: {
            DetailInfo,
            Activities,
            Signature,
        },
        data() {
            return {
                tabData:[
                    {
                        key: "basic-info",
                        title: "Basic Info",
                        active: true
                    },         
                ],
                tableItems: [],
                loadingDetail: false,
                loadingSave: false,
                timer_save: null,
                timer_report: null,
                isTyping: false,
                isSave: false,
            }
        },
        computed: {
            ...mapGetters({
                User : 'AuthController/user',
                Item: 'SafetyAppController/safetyJob',
            }),
            isDisabledSave() {
                return this.Item && this.Item.id && this.Item.status != 'New';
            },
        },
        watch: {
            Item: function() {
                if(this.tabData.length == 1 && this.Item && this.Item.id) {
                    this.tabData = [
                        {
                            key: "basic-info",
                            title: "Basic Info",
                            active: true
                        },
                        {
                            key: "signature",
                            title: "Signature",
                            active: false
                        },
                        {
                            key: "activity-log",
                            title: "Activity Log",
                            active: false
                        }
                    ]
                }
            },
            isTyping: function(val) {
                if(val === false && this.isSave === true) {
                    this.updateData();
                }
            }
        }, 
        mounted() {
        },
        created() {
            if (
                !this.$route.params.hasOwnProperty("id") ||
                isNaN(this.$route.params.id)
            ) {
                return this.$router.push({
                    name: "non-conformance-report-list"
                });
            }
            this.getItem()
        },
        methods: {
            /*-- Get Data --------*/
            async getItem() {
                this.loadingDetail = true
                await this.$store.dispatch( 'SafetyAppController/getNonConformanceReportItem', this.$route.params.id)
                .then(response => {
                    this.loadingDetail = false
                })
                .catch(err => {
                    console.log(err)
                    this.loadingDetail = false
                })
            },
            changeStatus() {
                this.$refs['basic-info'].editBacsicInfo()
            },

            /*-- Store Data --------*/
            setIsTyping(value) {
                this.isTyping = value;
            },
            saveData() {
                if (this.timer_save) {
                    clearTimeout(this.timer_save);
                    this.timer_save = null;
                }
                this.timer_save = setTimeout(async () => {
                    const data = this.$refs['basic-info'].info;
                    const validate_fields = [
                        { key: 'project', name: 'Project'},
                        { key: 'date', name: 'Date'},
                        { key: 'time', name: 'Time'},
                        { key: 'supplier', name: 'Subcontractor'},
                        { key: 'contractor_supervisor_by', name: 'Subcontractor User'},
                        { key: 'equipment', name: 'Location'},
                    ]
                    const is_validate = this.$validationData(validate_fields, data)
                    if(is_validate) return

                    if(this.loadingSave) return;
                    this.loadingSave = true;

                    if(!this.isTyping) {
                        this.updateData();
                    }

                    this.isSave = true;

                    let objeClone = {
                        data: {
                            id: data.id,
                            client_contract_id: data.client_contract_id,
                            project_id: data.project.id,
                            location_id: data.equipment.location_id,
                            location: data.equipment.name,
                            // equipment_id: data.equipment.equipment_id,
                            // equipment_lift_number: data.equipment.equipment_lift_number,
                            // equipment_type: data.equipment.equipment_type,
                            contractor_supervisor_id: data.contractor_supervisor_by.user_id,
                            supplier_id: data.supplier.id,
                            supplier: data.supplier.name,
                            created_at_manual: null,
                            role_id: data.role_id,
                            // checklist_template_id: data.checklist_template_id,
                        },
                        attachment: {
                            supporting_documents_file: null,
                            photos: []
                        }
                    };

                    if(objeClone.data.id) {
                        objeClone.data.supporting_documents = JSON.parse(JSON.stringify(data.supporting_documents))
                    }

                    if(data.date && data.time) {
                        objeClone.data.created_at_manual = moment(data.date).format("YYYY-MM-DD") + ' ' + data.time
                    }

                    const attachment = this.$refs['basic-info'].attachment;
                    objeClone.attachment.supporting_documents_file = attachment.project_file_push
                    objeClone.attachment.photos = attachment.items

                    if(data.project && data.project.client_contract_id) {
                        objeClone.data.client_contract_id = data.project.client_contract_id
                    }
    
                    this.$store.dispatch(`SafetyAppController/saveNonConformanceReportItem`, objeClone)
                    .then(async response => {
                        this.loadingSave = false;
                        if(response.code && response.message) {
                            this.$alertNotification(response.message, "danger");
                            return;
                        }
                        this.$refs['basic-info'].resetData()
                        if (this.$route.params.id == "0") {
                            await this.$router.push(`/v2/non-conformance-report/${response.id}`)
                        }
                        await this.getItem()
                        this.isSave = false;
                        this.$alertNotification(this.$notificationV2(data.id ? 'editing' : 'adding', 'non_conformance_report'), "success");
                    })
                    .catch(err => {
                        console.log(err)
                        this.isSave = false;
                        this.loadingSave = false;
                        if( err.response.data.error && err.response.data.error.message ) {
                            this.$alertNotification(err.response.data.error.message, "danger"); 
                        }
                    })

                }, 200);
            },
            updateData() {
                if(this.$route.params.id == 0) return
                const checkListEntryUpdate = this.$refs['basic-info'].checkListEntryUpdate;
                let request = {
                    array_data: JSON.stringify(checkListEntryUpdate),
                    job_id: this.$route.params.id
                };
                this.$store
                    .dispatch("SafetyAppController/updateCheckListJob", request)
                    .then(async (data) => {
                        this.$refs['basic-info'].resetDataChecklist()
                    })
                    .catch((err) => {
                        this.$alertNotification("Can not update checklist!", "danger");
                    });
            },
            reportJob() {
                if (this.timer_report) {
                    clearTimeout(this.timer_report);
                    this.timer_report = null;
                }
                this.timer_report = setTimeout(() => {
                    let nameFile = `${this.Item.job_number}.pdf`;
                    this.$store.dispatch("SafetyAppController/reportNonConformanceReportItem", this.Item.id)
                    .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', nameFile);
                        document.body.appendChild(link);
                        link.click();
                    });
                }, 300);
            },
        }
    }
</script>